import { Box, Typography } from "@mui/material";
import useAuth0 from "../Auth0Provider/use-auth0";
import React from "react";

const UserDeactivatedScreen = () => {
  const { logout } = useAuth0();
  return (
      <Box
        className={
          "h-[100vh] w-full bg-[#FFFFFF] justify-center items-center flex flex-col gap-2"
        }
      >
        <img src={require("@assets/OrganoxLogo.png")} alt={"logo"} />
        <Typography>User account is deactivated</Typography>
        <Box className="flex">
          <Typography>Please sign in with another account: </Typography>
          <Typography
            className="pl-1 underline underline-offset-1 text-[#0077B2] cursor-pointer "
            onClick={() =>
              logout({
                logoutParams: { returnTo: window.location.origin },
              })
            }
          >
            Sign In
          </Typography>
        </Box>
      </Box>
  );
};

export default UserDeactivatedScreen;
